import Vue from 'vue'
import {ebus} from '../vendor/ebus';

const plugin = {
    install () {
        Vue.ebus = ebus;
        Vue.prototype.$ebus = ebus
    }
};

// Vue.use(plugin);

export default plugin;

